// extracted by mini-css-extract-plugin
export default {"expertFigure":"VrHhV","expertImg":"eWGni"};